<template>
  <NuxtLayout>
    <div class="faqPage container--Medium defaultSectionMargins">
      <h1 v-text="page.title" />

      <CMSField v-if="page?.content" :data="page.content" />
    </div> 
  </NuxtLayout>
</template>

<script setup>
  defineOptions({
    auth: 'aminess'
  });
  
  defineProps({
    page: {}
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_faq.scss');
</style>